import { Link, Skeleton, styled, Typography } from "@mui/material";

const Container = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
	width: "100%",
	padding: "1rem",
	borderRadius: "16px",
	background: theme.palette.background.paper,
	margin: "0.5rem 0rem 0rem 0rem",
}));

const Heading = styled(Typography)(({ theme }) => ({
	margin: "0rem 0rem 1.25rem 0rem",
	width: "100%",
	fontWeight: "500",
	fontSize: "1rem",
	[theme.breakpoints.up("sm")]: {
		fontSize: "1rem",
	},
	[theme.breakpoints.up("md1190")]: {
		fontSize: "1.125rem",
	},
}));

const ContactDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	alignItems: "flex-start",
	width: "100%",
	gap: "0.5rem",
	[theme.breakpoints.up("md1190")]: {
		margin: "0rem 0rem 1rem 0rem",
	},
	[theme.breakpoints.down("md1190")]: {
		flexDirection: "row",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		gap: "0.75rem",
	},
}));

const ContactName = styled(Link)(({ theme }) => ({
	fontWeight: "400",
	fontSize: "0.875rem",
	gap: "0.5rem",
	[theme.breakpoints.up("md1190")]: {
		fontSize: "1rem",
	},
	color: theme.palette.mode == "dark" ? "#ffffff" : "#000000",
	textDecoration: "none",
	textAlign: "left",
	"&:hover": {
		color: theme.palette.primary.main,
	},
	// [theme.breakpoints.up("md")]: {
	// 	textAlign: "center",
	// },
}));

const ContactDetailsCardDesktopSkeleton = () => {
	return (
		<Container>
			<Heading>
				<Skeleton
					animation="wave"
					variant="rectangular"
					width="5rem"
					height="1rem"
					style={{ borderRadius: "0.5rem" }}
				/>
			</Heading>
			<ContactDiv>
				<Skeleton
					animation="wave"
					variant="rectangular"
					width="3.75rem"
					height="3.75rem"
					style={{ borderRadius: "8px" }}
				/>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "0.5rem",
					}}
				>
					<Skeleton
						animation="wave"
						variant="rectangular"
						width="10rem"
						height="1rem"
						style={{ borderRadius: "0.5rem" }}
					/>
					<Skeleton
						animation="wave"
						variant="rectangular"
						width="5rem"
						height="1rem"
						style={{ borderRadius: "0.5rem" }}
					/>
				</div>
			</ContactDiv>
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                gap: "0.5rem",
            }}>
				<Skeleton
					animation="wave"
					variant="rectangular"
					width="100%"
					height="3rem"
					style={{ borderRadius: "0.5rem" }}
				/>
				<Skeleton
					animation="wave"
					variant="rectangular"
					width="100%"
					height="3rem"
					style={{ borderRadius: "0.5rem" }}
				/>
			</div>
		</Container>
	);
};

export default ContactDetailsCardDesktopSkeleton;
